import type { AnalysisType } from "./dataAnalysisUtils";

export const CHART_TYPES: Set<AnalysisType> = new Set<AnalysisType>([
  "histogram",
  "boxplot",
  "scatter",
  "fft",
  "polyFit",
  "line",
  "bar",
  "heatmap",
  "surface",
  "scatter3d",
  "correlation",
  "contour",
]);

/** Skip Pyodide entirely; data goes straight to buildPlotlyFigure. */
export const CLIENT_ONLY_CHART_TYPES = new Set<AnalysisType>([
  "boxplot",
  "scatter",
  "line",
  "bar",
  "heatmap",
  "surface",
  "scatter3d",
  "contour",
]);

/** Grid lives in Plotly scene axes here, so the Grid control is hidden for these. */
export const THREE_D_CHART_TYPES = new Set<AnalysisType>([
  "heatmap",
  "surface",
  "scatter3d",
  "correlation",
  "contour",
]);

/** Analysis types that require 2D (matrix) data */
export const TYPES_2D = new Set<AnalysisType>([
  "heatmap",
  "surface",
  "scatter3d",
  "correlation",
  "contour",
]);

export const STATS_TYPES: AnalysisType[] = ["descriptive"];

export const VIZ_TYPES_1D: AnalysisType[] = [
  "histogram",
  "boxplot",
  "scatter",
  "fft",
  "polyFit",
  "line",
  "bar",
];

export const VIZ_TYPES_2D: AnalysisType[] = [
  "heatmap",
  "surface",
  "scatter3d",
  "correlation",
  "contour",
];
